// extracted by mini-css-extract-plugin
module.exports = {"appandcategoriestabContainer":"AppAndCategoriesTab_appandcategoriestabContainer__3LrTl"};